import { createGlobalStyle, css } from 'styled-components';
import { BrandColor, FontType, FunctionColor, mediaMaxWidth } from '@lux/core';

interface GlobalStyleProps {
    isPlus?: boolean;
}

export const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
    html {
        box-sizing: border-box;
        --image-radial-gradient: radial-gradient(ellipse at center, transparent 0, transparent 40%, rgba(0, 0, 0, .08) 100%);
        scroll-padding-top: 125px;
    }

    body {
        background-color: ${FunctionColor.function0};
        font-family: ${FontType.default};
        overflow-y: scroll;
        color: ${FunctionColor.function100};
        margin: 0;

        ${props =>
            props.isPlus &&
            css`
                background: linear-gradient(95deg, #252336 0%, #0a0514 100%);
                color: ${FunctionColor.function0};
                font-family: ${FontType.default};

                ${mediaMaxWidth.sm} {
                    background: #0a0514;
                }
            `}
    }

    *, :before, :after {
        box-sizing: inherit;
    }

    a {
        text-decoration: none;
        color: ${BrandColor.primary};
    }

    ul {
        padding: 0;
        margin: 0;
        list-style: none
    }
    sub,sup {
        font-size: 55%;
        line-height: 0;
        position: relative;
        vertical-align: baseline
    }

    sup {
        top: -.8em
    }

    sub {
        bottom: -.25em
    }

`;
